const jsonDefaultSchema = {
    "type": "object",
    "title": "Ne postoji ispravna forma za ovaj zahtjev",
}
export {jsonDefaultSchema}